export default __webpack_public_path__ + "static/media/faviconexpresspcp.0c1dd610.ico";